<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>课程目录管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateCourseCategoryDialog()">
          新增课程目录
        </v-btn>
      </v-col>
    </v-row>
    
    <v-data-table
      :headers="headers"
      :items="categories"
      :items-per-page="5"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditCategoryDialog(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn small @click="showDeleteCategoryConfirm(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <create-course-category-popup 
    ref="createCourseCategoryPopup"
    @category-created="handleCategoryCreated"
    ></create-course-category-popup>
    
    <edit-course-category-popup
      ref="editCourseCategoryPopup"
      :item="selectedCategory"
      @category-updated="handleCategoryUpdated"
    ></edit-course-category-popup>

    <delete-course-category-confirmation
      ref="deleteCourseCategoryConfirmation"
      :item="selectedCategory"
      @course-category-deleted="handleCourseCategoryDeleted"
    ></delete-course-category-confirmation>
  </v-container>
</template>

<script>
import { courseApi } from '@/api/course'

export default {
  components: {
    CreateCourseCategoryPopup: () => import('@/components/CreateCourseCategoryPopup.vue'),
    DeleteCourseCategoryConfirmation: () => import('@/components/DeleteCourseCategoryConfirmation.vue'),
    EditCourseCategoryPopup: () => import('@/components/EditCourseCategoryPopup.vue')
  },
  created() {
    this.fetchCategories();
  },
  data() {
    return {
      headers: [
        { text: "课程目录名称", value: "name" },
        { text: "创建时间", value: "createdDateTime" },
        { text: "操作", value: "actions", sortable: false },
      ],
      categories: [],
      selectedCategory: {"name": "", "createdDate": ""},
      selectedCategories: [],
      loading: false,
    }
  },
  methods: {
    showEditCategoryDialog(item) {
      this.selectedCategory = item;
      this.$refs.editCourseCategoryPopup.open(item);
    },
    showDeleteCategoryConfirm(item) {
      this.selectedCategory = item;
      this.$refs.deleteCourseCategoryConfirmation.open();
    },
    
    async handleCategoryUpdated() {
      this.fetchCategories();
    },

    showCreateCourseCategoryDialog() {
      this.$refs.createCourseCategoryPopup.open();
    },

    handleCategoryCreated() {
      this.fetchCategories();
    },

    handleCourseCategoryDeleted() {
      this.fetchCategories();
    },

    async fetchCategories() {
      this.loading = true;
      try {
        const response = await courseApi.getCourseCategories();
        console.log('categories response = ' , response);
        this.categories = response.data.map(category => ({
          ...category,
          id: category.id,
          name: category.name
        }));
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取分类列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.v-chip {
  margin-right: 8px;
}
</style>